import { getBackendUrl } from "./config";

export interface LookupResponse {
  pin: string;
  deviceType: string;
  jwt: string;
  refreshToken: string;
  publisherId: string;
  offerId: string;
}

export const lookupPin = async (pin: string): Promise<LookupResponse> => {
  const response = await fetch(getBackendUrl(`/lookup/${pin}`));

  if (!response.ok) {
    throw new Error("Ongeldige PIN of serverfout");
  }

  return response.json();
};

export const completePin = async (pin: string): Promise<void> => {
  try {
    await fetch(getBackendUrl("/complete"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pin }),
    });
  } catch (error) {
    console.warn("Failed to complete PIN:", error);
  }
};
